const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. Carga de archivo',
      body: {
        btn: 'Cargar',
        hint: 'Selecciona el CSV que deseas importar',
        downloadExample: 'Descargar ejemplo CSV',
        templateLabel: 'Seleccionar plantilla de mapeo (opcional)',
        templateDescription: 'Plantilla cargada. Puede ver o editar la configuración a continuación si es necesario.',
        advanced: {
          hint: 'Selecciona los archivos que deseas importar',
        },
      },
    },
    mappingFields: {
      title: '2. Mapeo de campos',
      subTitle: 'Confirme que cada atributo coincida con la columna correcta',
      toast: 'Valor duplicado',
      selectInputPlaceHolder: 'Seleccionar campo'
    },
    integrityCheck: {
      title: '3. Verificación de Integridad',
      subTitle: 'Verificando los valores del archivo',
    },
    import: {
      title: '4. Importar',
      subTitle: 'Importar los datos',
      doneText: 'Archivo importado correctamente',
      doneBtn: 'Listo',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Campos en la base de datos',
      csvFile: 'Archivo CSV',
      format: 'Formato',
      defaultValue: 'Valor predeterminado',
    },
    hideTableBtn: 'Ocultar tabla',
    showTableBtn: 'Mostrar tabla',
    saveAsTemplateBtn: 'Guardar como plantilla',
    templateNameLabel: 'Nombre de la plantilla',
    saveTemplateDescription: 'Guarde sus mapeos de campos actuales como una plantilla para uso futuro.',
    updateTemplateDescription: 'Puede actualizar la plantilla existente {{templateName}} o guardar como una nueva plantilla.',
    saveTemplateBtn: 'Guardar',
    saveAsNewBtn: 'Guardar como nueva',
    updateTemplateBtn: 'Actualizar plantilla',
    nextBtn: 'Siguiente',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Mostrar solo problemas',
    disableSubmit: 'Saltar errores',
    totalCount: 'Total: {{count}}',
    exportErrorList: 'Exportar lista de errores',
    rowContainErroe: 'La fila {{count}} contiene error.',
    importBtn: 'Importar',
    sourceFileColumn: 'Archivo de origen',
    sourceRowColumn: 'Fila de origen',
    sourceFileFilterAll: 'Todos los {{count}} archivos de origen',
  },

  submit: {
    errors: 'No se pudieron enviar las filas {{errors}}',
  }
};

export default dataUpload;
